/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccount } from './BankAccount';
import {
    BankAccountFromJSON,
    BankAccountFromJSONTyped,
    BankAccountToJSON,
    BankAccountToJSONTyped,
} from './BankAccount';
import type { CreditCard } from './CreditCard';
import {
    CreditCardFromJSON,
    CreditCardFromJSONTyped,
    CreditCardToJSON,
    CreditCardToJSONTyped,
} from './CreditCard';

/**
 * 
 * @export
 * @interface GetAllPaymentMethodsResponse
 */
export interface GetAllPaymentMethodsResponse {
    /**
     * 
     * @type {Array<CreditCard>}
     * @memberof GetAllPaymentMethodsResponse
     */
    creditCards: Array<CreditCard>;
    /**
     * 
     * @type {Array<BankAccount>}
     * @memberof GetAllPaymentMethodsResponse
     */
    bankAccounts: Array<BankAccount>;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllPaymentMethodsResponse
     */
    isEtransferPaymentPermitted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllPaymentMethodsResponse
     */
    isChequePaymentPermitted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllPaymentMethodsResponse
     */
    isWirePaymentPermitted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllPaymentMethodsResponse
     */
    isEftPaymentPermitted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAllPaymentMethodsResponse
     */
    defaultPaymentMethod?: string;
}

/**
 * Check if a given object implements the GetAllPaymentMethodsResponse interface.
 */
export function instanceOfGetAllPaymentMethodsResponse(value: object): value is GetAllPaymentMethodsResponse {
    if (!('creditCards' in value) || value['creditCards'] === undefined) return false;
    if (!('bankAccounts' in value) || value['bankAccounts'] === undefined) return false;
    if (!('isEtransferPaymentPermitted' in value) || value['isEtransferPaymentPermitted'] === undefined) return false;
    if (!('isChequePaymentPermitted' in value) || value['isChequePaymentPermitted'] === undefined) return false;
    if (!('isWirePaymentPermitted' in value) || value['isWirePaymentPermitted'] === undefined) return false;
    if (!('isEftPaymentPermitted' in value) || value['isEftPaymentPermitted'] === undefined) return false;
    return true;
}

export function GetAllPaymentMethodsResponseFromJSON(json: any): GetAllPaymentMethodsResponse {
    return GetAllPaymentMethodsResponseFromJSONTyped(json, false);
}

export function GetAllPaymentMethodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllPaymentMethodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'creditCards': ((json['creditCards'] as Array<any>).map(CreditCardFromJSON)),
        'bankAccounts': ((json['bankAccounts'] as Array<any>).map(BankAccountFromJSON)),
        'isEtransferPaymentPermitted': json['isEtransferPaymentPermitted'],
        'isChequePaymentPermitted': json['isChequePaymentPermitted'],
        'isWirePaymentPermitted': json['isWirePaymentPermitted'],
        'isEftPaymentPermitted': json['isEftPaymentPermitted'],
        'defaultPaymentMethod': json['defaultPaymentMethod'] == null ? undefined : json['defaultPaymentMethod'],
    };
}

  export function GetAllPaymentMethodsResponseToJSON(json: any): GetAllPaymentMethodsResponse {
      return GetAllPaymentMethodsResponseToJSONTyped(json, false);
  }

  export function GetAllPaymentMethodsResponseToJSONTyped(value?: GetAllPaymentMethodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditCards': ((value['creditCards'] as Array<any>).map(CreditCardToJSON)),
        'bankAccounts': ((value['bankAccounts'] as Array<any>).map(BankAccountToJSON)),
        'isEtransferPaymentPermitted': value['isEtransferPaymentPermitted'],
        'isChequePaymentPermitted': value['isChequePaymentPermitted'],
        'isWirePaymentPermitted': value['isWirePaymentPermitted'],
        'isEftPaymentPermitted': value['isEftPaymentPermitted'],
        'defaultPaymentMethod': value['defaultPaymentMethod'],
    };
}

